import React from 'react';
import type { FC } from 'react';

import { Button, ButtonType } from '@/common/button';
import { FloatingPanel, FloatingPanelItem, FloatingPanelType } from '@/common/floating-panel';
import { useTemplateEditorStore } from '../store';
import type { Field, Layer } from '../types';
import { FieldCard } from './field-card';

export interface ImageLayerEditViewProps {
    layer: Layer;
    onClose: () => void;
    onCreateField: () => void;
    onLinkField: () => void;
}

export const ImageLayerEditView: FC<ImageLayerEditViewProps> = ({ layer, onClose, onCreateField, onLinkField }) => {
    const width = useTemplateEditorStore((s) => s.fieldsPanelWidth);
    // TODO: Fetch field associated with the layer
    const field: Field | null = null;

    return (
        <FloatingPanel
            className="pr-4 py-4 h-full flex-shrink-0 overflow-y-auto"
            type={FloatingPanelType.LIGHT}
            width={width}
        >
            <FloatingPanelItem className="flex flex-row justify-between items-center px-4">
                <p className="text-sm text-white font-medium">Image Layer</p>
                <button
                    title="Cancel"
                    className="text-white text-xs font-normal h-5"
                    type="button"
                    onClick={() => onClose()}
                >
                    Cancel
                </button>
            </FloatingPanelItem>

            <FloatingPanelItem className="h-full px-4">
                <div className="flex flex-col gap-3">
                    <p className="text-sm text-white font-semibold">Details</p>
                    <div className="flex flex-row gap-2">
                        <div className="flex flex-col gap-1 w-[130px]">
                            <p className="text-sm text-gray-110 ">Dimensions</p>
                            <p className="text-sm text-gray-110 ">Position</p>
                        </div>
                        <div className="flex flex-col gap-1 w-full">
                            <p className="text-sm text-white ">W 300px H 150 px</p>
                            <p className="text-sm text-white ">X 125 Y 125</p>
                        </div>
                    </div>
                    <hr className="bg-gray-100 border-gray-100 w-full" />
                    <div className="flex flex-row justify-between">
                        <p className="text-sm text-white font-semibold">Content Field</p>
                        <p className={`text-sm ${field?.linked ? 'text-green' : 'text-gray-110'} font-semibold`}>
                            {field?.linked ? 'Linked' : 'Not Linked'}
                        </p>
                    </div>
                    {field?.linked && <FieldCard showMenu={false} showLinkButton={false} isImage={true} />}
                    {field?.linked ? (
                        <Button title="Unlink" buttonType={ButtonType.SECONDARY} onClick={() => {}} />
                    ) : // TODO: Replace with actual check
                    true ? (
                        <Button
                            title="Link to Image Field"
                            buttonType={ButtonType.PRIMARY}
                            onClick={() => onLinkField()}
                        />
                    ) : (
                        <Button
                            title="Create New Image Field"
                            buttonType={ButtonType.PRIMARY}
                            onClick={() => onCreateField}
                        />
                    )}
                </div>
            </FloatingPanelItem>
        </FloatingPanel>
    );
};
